const editableFields = document.querySelectorAll(".js-editable-field-DEMO");

if (editableFields) {
    editableFields.forEach((field) => {
        const trigger = field.querySelector(".js-editable-field-value");
        const input = field.querySelector(".js-editable-field-input");

        trigger.addEventListener("click", () => {
            field.classList.toggle("active");

            const hasParentTable = input.closest("table");

            if (hasParentTable) {
                const elementBottom = input.getBoundingClientRect().bottom;
                const parentBottom = hasParentTable.getBoundingClientRect().bottom;

                if (elementBottom > parentBottom) {
                    input.style.top = "-100%";
                }
            }

            input.value = trigger.textContent.replace(/\s/g, "");
            input.focus();

            input.addEventListener("input", () => {
                trigger.textContent = Number(input.value).toLocaleString("ru-RU");
            });

            window.addEventListener("click", (e) => {
                if (!field.contains(e.target)) field.classList.remove("active");
            });
        });
    });
}
